import * as React from "react";
import { cn } from "../utils/cn";

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, label, ...props }, ref) => {
    return (
      <div className="w-full">
        {label && (
          <label
            htmlFor={props.id}
            className="block mb-2 text-sm font-medium text-juridico"
          >
            {label}
          </label>
        )}
        <div className={cn("mt-2", !label && "mt-0")}>
          <textarea
            id={props.id}
            name={props.name}
            placeholder={props.placeholder}
            className={cn(
              "block min-h-[120px] w-full rounded-md border-2 border-tiber-200 bg-romance-50 px-3 py-2 text-base text-juridico placeholder:text-titan focus:outline-none focus:ring-2 focus:ring-tiber-600 focus:border-transparent transition-all duration-200 sm:text-sm/6 resize-y",
              className
            )}
            ref={ref}
            {...props}
          />
        </div>
      </div>
    );
  }
);

Textarea.displayName = "Textarea";

export { Textarea };
